import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../../../utils/@reduxjs/toolkit';
import { ContainerState } from './types';

export const initialState: ContainerState = {
    data: null,
    isLoading: false,
    hasError: false,
    errorMessage: null,
};

export const mainMenuSlice = createSlice({
    name: 'otherKindCodes',
    initialState,
    reducers: {
        searchOtherKindCodes(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                isLoading: true,
                hasError: false,
            };
        },
        searchOtherKindCodesSuccess(state: any, { payload }: PayloadAction<object | null>) {
            return {
                ...state,
                data: payload,
                isLoading: false,
                hasError: false,
            };
        },
        searchOtherKindCodesError(state: any, { payload }: PayloadAction<Error>) {
            return {
                ...state,
                isLoading: false,
                hasError: true,
                errorMessage: payload,
            };
        },
        clearError(state: any) {
            return {
                ...state,
                isLoading: false,
                hasError: false,
                errorMessage: null,
            };
        },
    },
});

export const { actions, reducer, name: sliceKey } = mainMenuSlice;
